import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_STAFFROLES_URL = `${process.env.PUBLIC_URL}/api/v1/r/staffRoles`;

export const GET_STAFFROLES = 'GET_STAFFROLES';
export const GET_STAFFROLES_COMPLETED = 'GET_STAFFROLES_COMPLETED';
export const GET_STAFFROLES_FAILED = 'GET_STAFFROLES_FAILED';
export function getStaffRoles() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_STAFFROLES_URL, queryFilter, GET_STAFFROLES, GET_STAFFROLES_COMPLETED, GET_STAFFROLES_FAILED);
}

export const SEARCH_STAFF_ROLES = 'SEARCH_STAFF_ROLES';
export const SEARCH_STAFF_ROLES_COMPLETED = 'SEARCH_STAFF_ROLES_COMPLETED';
export const SEARCH_STAFF_ROLES_FAILED = 'SEARCH_STAFF_ROLES_FAILED';
export const searchStaffRoles = querySearch(GET_STAFFROLES_URL, SEARCH_STAFF_ROLES, SEARCH_STAFF_ROLES_COMPLETED,
  SEARCH_STAFF_ROLES_FAILED, 'name');

export const GET_INVENTORYTAKER = 'GET_INVENTORYTAKER';
export const GET_INVENTORYTAKER_COMPLETED = 'GET_INVENTORYTAKER_COMPLETED';
export const GET_INVENTORYTAKER_FAILED = 'GET_INVENTORYTAKER_FAILED';
export function getStaffRole({staffRoleId}) {
  return queryOne(GET_STAFFROLES_URL, {where: {staffRoleId}}, GET_INVENTORYTAKER, GET_INVENTORYTAKER_COMPLETED, GET_INVENTORYTAKER_FAILED);
}

const ADD_INVENTORYTAKER_URL = `${process.env.PUBLIC_URL}/api/v1/staffRole/addStaffRole`;
export const ADD_INVENTORYTAKER = 'ADD_INVENTORYTAKER';
export const ADD_INVENTORYTAKER_COMPLETED = 'ADD_INVENTORYTAKER_COMPLETED';
export const ADD_INVENTORYTAKER_FAILED = 'ADD_INVENTORYTAKER_FAILED';
export const addStaffRole = command(ADD_INVENTORYTAKER_URL, ADD_INVENTORYTAKER, ADD_INVENTORYTAKER_COMPLETED, ADD_INVENTORYTAKER_FAILED);

const UPDATE_INVENTORYTAKER_URL = `${process.env.PUBLIC_URL}/api/v1/staffRole/updateStaffRole`;
export const UPDATE_INVENTORYTAKER = 'UPDATE_INVENTORYTAKER';
export const UPDATE_INVENTORYTAKER_COMPLETED = 'UPDATE_INVENTORYTAKER_COMPLETED';
export const UPDATE_INVENTORYTAKER_FAILED = 'UPDATE_INVENTORYTAKER_FAILED';
export const updateStaffRole = command(UPDATE_INVENTORYTAKER_URL, UPDATE_INVENTORYTAKER, UPDATE_INVENTORYTAKER_COMPLETED,
  UPDATE_INVENTORYTAKER_FAILED);



// WEBPACK FOOTER //
// ./src/StaffRole/actions.js